import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './App';
import './index.css';
import log from 'loglevel';
import { DEBUG } from './remote/config';

// 在生产环境中设置日志级别为 error，其他环境保持 debug 级别
if (!DEBUG) {
    log.setLevel('error');
} else {
    log.setLevel('debug');
}

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    DEBUG ? (
        <React.StrictMode>
            <Provider store={store}>
                <App />
            </Provider>
        </React.StrictMode>
    ) : (
        <Provider store={store}>
            <App />
        </Provider>
    )
);